import { LOCALSTORAGE_TOKEN, LOCALSTORAGE_USER_ID } from "../../config";
import axios from "axios";

export async function getCurrentUserInfoService() {
  const userId = localStorage.getItem(LOCALSTORAGE_USER_ID);
  return getUserById(userId);
}

export async function getUserById(userId) {
  if (!userId) throw `${userId} is not a valid userId`;
  let token = localStorage.getItem(LOCALSTORAGE_TOKEN);
  let config = { headers: { Authorization: `bearer ${token}` } };
  const data = await axios.get(
    `${process.env.API_BASE_URL}/api/users/${userId}`,
    config
  );
  return data.data.data;
}



// WEBPACK FOOTER //
// ./src/modules/user/services.js